import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { Moon, Sun, User, SignOut, List, X, ShieldCheck, SquaresFour } from '@phosphor-icons/react';
import { Button } from './ui/button';
import { BrandLogo } from './BrandLogo';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-background/70 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <BrandLogo size={36} withText={true} />
          </Link>

          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <>
                <Link to="/dashboard" data-testid="navbar-dashboard-link">
                  <Button variant="ghost" className="flex items-center gap-2">
                    <SquaresFour size={20} />
                    Dashboard
                  </Button>
                </Link>
                {user.role === 'admin' && (
                  <Link to="/admin" data-testid="navbar-admin-link">
                    <Button variant="ghost" className="flex items-center gap-2">
                      <ShieldCheck size={20} />
                      Admin
                    </Button>
                  </Link>
                )}
                <Button
                  variant="ghost"
                  onClick={handleLogout}
                  className="flex items-center gap-2"
                  data-testid="navbar-logout-button"
                >
                  <SignOut size={20} />
                  Salir
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="navbar-login-link">
                  <Button variant="ghost">Iniciar Sesión</Button>
                </Link>
                <Link to="/register" data-testid="navbar-register-link">
                  <Button>Registrarse</Button>
                </Link>
              </>
            )}
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleTheme}
              data-testid="navbar-theme-toggle"
            >
              {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
            </Button>
          </div>

          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="navbar-mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden border-t border-border bg-background">
          <div className="px-4 py-4 space-y-2">
            {user ? (
              <>
                <Link to="/dashboard" className="block" onClick={() => setMobileMenuOpen(false)}>
                  <Button variant="ghost" className="w-full justify-start">
                    <SquaresFour size={20} className="mr-2" />
                    Dashboard
                  </Button>
                </Link>
                {user.role === 'admin' && (
                  <Link to="/admin" className="block" onClick={() => setMobileMenuOpen(false)}>
                    <Button variant="ghost" className="w-full justify-start">
                      <ShieldCheck size={20} className="mr-2" />
                      Admin
                    </Button>
                  </Link>
                )}
                <Button
                  variant="ghost"
                  onClick={() => {
                    handleLogout();
                    setMobileMenuOpen(false);
                  }}
                  className="w-full justify-start"
                >
                  <SignOut size={20} className="mr-2" />
                  Salir
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" className="block" onClick={() => setMobileMenuOpen(false)}>
                  <Button variant="ghost" className="w-full">Iniciar Sesión</Button>
                </Link>
                <Link to="/register" className="block" onClick={() => setMobileMenuOpen(false)}>
                  <Button className="w-full">Registrarse</Button>
                </Link>
              </>
            )}
            <Button
              variant="ghost"
              onClick={toggleTheme}
              className="w-full justify-start"
            >
              {theme === 'light' ? (
                <><Moon size={20} className="mr-2" /> Modo Oscuro</>
              ) : (
                <><Sun size={20} className="mr-2" /> Modo Claro</>
              )}
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};